// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"d779d018","81":"cd9490bb","104":"a0d616ae","116":"574303bb","169":"893ab5e9","228":"4d245118","251":"9ce0aef2","379":"c5ff944b","453":"e81dc49e","519":"94ab0c42","740":"3c62771b","767":"2442ed33","878":"dfdd06ca"}[chunkId] + ".chunk.js";
};